import Service from "../components/Service"
import Seperator from "../components/Seperator";

export default function Services() {
  return (
  <>
  <Service/>
  <Seperator/>
  </>
  );
}